import { TableCell, Typography } from "@mui/material";
import { FormatDateAndTime, formatDistanceToNowStrict } from "~/lib/date";

type RelativeDateCellProps = {
  date: string | null | undefined;
  addSuffix?: boolean;
};

export const RelativeDateCell = ({
  date = "",
  addSuffix = false,
}: RelativeDateCellProps) => {
  return (
    <TableCell>
      <Typography fontSize={14}>
        {date ? formatDistanceToNowStrict(date, { addSuffix }) : "-"}
      </Typography>
      <Typography fontSize={12} color="text.secondary">
        {FormatDateAndTime(date)}
      </Typography>
    </TableCell>
  );
};
